import React from 'react';
import CustomButton from 'components/CustomInput/Button';
import { Grid, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomTextField from 'components/Input/CustomTextField';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CustomSelect from 'components/Input/CustomSelect';
import CustomRadio from 'components/CustomRadio';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { SET_PROTOCOL_DEVIATION_REPORT } from 'store/key';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    itemContent: {
        paddingTop: 20,
    },
    container: {
        border: '2px solid #999',
        borderRadius: 3,
        marginTop: 10,
    },
    textItem: {
        paddingRight: 20,
    },
    numberItem: {
        width: '2%',
        borderRight: '2px solid #999',
        justifyContent: 'center',
        paddingTop: 12,
    },
    detailItem: {
        width: '98%',
    },
    topItem: {
        borderBottom: '2px solid #999',
        padding: 12,
        position: 'relative',
    },
    desc: {
        borderBottom: '2px solid #999',
    },
    protocolDesc: {
        padding: 12,
        borderRight: '2px solid #999',
    },
    incidentDesc: {
        padding: 12,
    },
    causeRisks: {
        borderBottom: '2px solid #999',
    },
    AESAE: {
        borderRight: '2px solid #999',
        padding: 12,
    },
    risk: {
        padding: 12,
    },
    deviationAction: {},
    action: {
        padding: 12,
        borderRight: '2px solid #999',
    },
    deviation: {
        padding: 12,
    },
    textRight: {
        paddingRight: 10,
    },
    radioBox: {
        marginTop: -10,
    },
    deleteBtn: {
        width: 40,
        height: 40,
        position: 'absolute',
        top: -15,
        right: -15,
    },
}));

const ProtocolDeviationDetails = ({
    isPermission,
    protocolDeviationReport,
    handleChange,
    forceErrorDisplay,
    updateMaxLength,
}) => {
    const remoteDetail = protocolDeviationReport?.remoteDetail;
    const classes = useStyles();

    const dispatch = useDispatch();

    const defaultData = {};

    const rowList =
        remoteDetail?.protocolDeviationReportDetails?.length > 0
            ? remoteDetail?.protocolDeviationReportDetails
            : [{}] || [{}];

    const addItem = async () => {
        handleChange('protocolDeviationReportDetails', [...rowList, defaultData]);
    };
    const handleDeleteItem = (index) => {
        let copyRows = [...rowList];
        copyRows.splice(index, 1);
        handleChange('protocolDeviationReportDetails', copyRows);
    };

    const saveData = (name, value, index) => {
        let val = value;
        if (name === 'causeAe') {
            if (value * 1 === 1) val = true;
            else val = false;
        }
        if (name === 'increaseRisks') {
            if (value * 1 === 1) val = true;
            else val = false;
        }
        if (name === 'avoidDeviation') {
            if (value * 1 === 1) val = true;
            else val = false;
        }
        let data = { ...rowList[index], [name]: val };
        rowList[index] = data;
        if (name === 'causeAe' && value === 0) {
            rowList[index].aeRemarks = null;
        }
        if (name === 'increaseRisks' && value === 0) {
            rowList[index].risksRemark = null;
        }
        if (name === 'deviationCaused' && value !== 2) {
            rowList[index].deviationRemark = null;
        }
        dispatch({
            type: SET_PROTOCOL_DEVIATION_REPORT,
            payload: {
                remoteDetail: {
                    ...remoteDetail,
                    protocolDeviationReportDetails: rowList,
                },
            },
        });
    };

    return (
        <Grid className={classes.itemContent}>
            <TextSubHeader>2. Details of Protocol Deviation / Compliance Incident </TextSubHeader>
            {isPermission && (
                <CustomButton disabled={!isPermission} style={{ marginTop: 8 }} onClick={addItem}>
                    Add
                </CustomButton>
            )}
            {rowList.map((item, index) => (
                <Grid key={index} container className={classes.container}>
                    <Grid container className={classes.numberItem}>
                        {index + 1}
                    </Grid>
                    <Grid container className={classes.detailItem}>
                        <Grid container className={classes.topItem} wrap="nowrap">
                            <div style={{ flex: 1 }}>
                                <div style={{ width: 200 }}>
                                    <CustomDatePicker
                                        disabled={!isPermission}
                                        label="Date of Occurrence"
                                        value={item?.occurrenceDate || null}
                                        onChange={(value) => {
                                            saveData('occurrenceDate', value, index);
                                        }}
                                        validators={['isRequired']}
                                        forceErrorDisplay={forceErrorDisplay}
                                    />
                                </div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <CustomSelect
                                    style={{ width: 250 }}
                                    disabled={!isPermission}
                                    fullWidth
                                    options={[
                                        { key: 1, label: 'Major Deviation / Incident' },
                                        { key: 0, label: 'Minor Deviation / Incident' },
                                    ]}
                                    label="Type"
                                    name="type"
                                    value={item?.type ? 1 : item?.type === false || item?.type === 0 ? 0 : null}
                                    onChange={(e) => saveData('type', e.target.value, index)}
                                    validators={['isRequired']}
                                    forceErrorDisplay={forceErrorDisplay}
                                />
                            </div>
                            {rowList.length > 1 && isPermission && (
                                <IconButton
                                    className={classes.deleteBtn}
                                    onClick={() => handleDeleteItem(index)}
                                    size="small"
                                >
                                    <CancelIcon style={{ width: 30, height: 30 }} color="primary" />
                                </IconButton>
                            )}
                        </Grid>
                        <Grid container wrap="nowrap" className={classes.desc}>
                            <Grid container className={classes.protocolDesc}>
                                <CustomTextField
                                    disabled={!isPermission}
                                    isTextArea
                                    label="Description of Protocol Requirement"
                                    value={item?.protocolRequirementDesc}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={['isRequired']}
                                    maxLength={3000}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        updateMaxLength('protocolRequirementDesc', isMaxLengthValid);
                                    }}
                                    onChange={(e) => {
                                        saveData('protocolRequirementDesc', e.target.value, index);
                                    }}
                                />
                            </Grid>
                            <Grid container className={classes.incidentDesc}>
                                <CustomTextField
                                    disabled={!isPermission}
                                    isTextArea
                                    label="Description of Protocol Deviation / Compliance Incident"
                                    value={item?.protocolDeviationDesc}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={['isRequired']}
                                    maxLength={3000}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        updateMaxLength('protocolDeviationDesc', isMaxLengthValid);
                                    }}
                                    onChange={(e) => {
                                        saveData('protocolDeviationDesc', e.target.value, index);
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container wrap="nowrap" className={classes.causeRisks}>
                            <Grid container className={classes.AESAE}>
                                <div style={{ paddingBottom: 10 }}>
                                    <div>Did the deviation / incident cause AE / SAE?</div>
                                    <div>
                                        <CustomRadio
                                            disabled={!isPermission}
                                            operators={[
                                                { key: 1, label: 'Yes, please specify' },
                                                { key: 0, label: 'No' },
                                            ]}
                                            value={
                                                item?.causeAe
                                                    ? 1
                                                    : item?.causeAe === false || item?.causeAe === 0
                                                    ? 0
                                                    : null
                                            }
                                            onChange={(e, key) => {
                                                saveData('causeAe', key * 1, index);
                                            }}
                                            validators={['isRequired']}
                                            forceErrorDisplay={forceErrorDisplay}
                                            isRequired
                                        />
                                    </div>
                                </div>
                                <CustomTextField
                                    disabled={!isPermission || !item?.causeAe}
                                    isTextArea
                                    label="AE / SAE Remark"
                                    value={item?.aeRemarks}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={!item?.causeAe ? [] : ['isRequired']}
                                    maxLength={1000}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        updateMaxLength('aeRemarks', isMaxLengthValid);
                                    }}
                                    onChange={(e) => {
                                        saveData('aeRemarks', e.target.value, index);
                                    }}
                                />
                            </Grid>
                            <Grid container className={classes.risk}>
                                <div style={{ paddingBottom: 10 }}>
                                    <div>Increase the risks to subject?</div>
                                    <div>
                                        <CustomRadio
                                            disabled={!isPermission}
                                            operators={[
                                                { key: 1, label: 'Yes, please specify' },
                                                { key: 0, label: 'No' },
                                            ]}
                                            value={
                                                item?.increaseRisks
                                                    ? 1
                                                    : item?.increaseRisks === false || item?.increaseRisks === 0
                                                    ? 0
                                                    : null
                                            }
                                            onChange={(e, key) => {
                                                saveData('increaseRisks', key * 1, index);
                                            }}
                                            validators={['isRequired']}
                                            forceErrorDisplay={forceErrorDisplay}
                                            isRequired
                                        />
                                    </div>
                                </div>
                                <CustomTextField
                                    disabled={!isPermission || !item?.increaseRisks}
                                    isTextArea
                                    label="Risk Remark"
                                    value={item?.risksRemark}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={!item?.increaseRisks ? [] : ['isRequired']}
                                    maxLength={1000}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        updateMaxLength('risksRemark', isMaxLengthValid);
                                    }}
                                    onChange={(e) => {
                                        saveData('risksRemark', e.target.value, index);
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container wrap="nowrap" className={classes.deviationAction}>
                            <Grid container className={classes.action}>
                                <div style={{ paddingBottom: 10 }}>
                                    <div>Any action to avoid similar deviation / incident in the future?</div>
                                    <div>
                                        <CustomRadio
                                            disabled={!isPermission}
                                            operators={[
                                                { key: 1, label: 'Yes, please specify' },
                                                { key: 0, label: 'No, justification' },
                                            ]}
                                            value={
                                                item?.avoidDeviation
                                                    ? 1
                                                    : item?.avoidDeviation === false || item?.avoidDeviation === 0
                                                    ? 0
                                                    : null
                                            }
                                            onChange={(e, key) => {
                                                saveData('avoidDeviation', key * 1, index);
                                            }}
                                            validators={['isRequired']}
                                            forceErrorDisplay={forceErrorDisplay}
                                            isRequired
                                        />
                                    </div>
                                </div>
                                <CustomTextField
                                    disabled={!isPermission}
                                    isTextArea
                                    label="Action Remark"
                                    value={item?.actionRemarks}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={['isRequired']}
                                    maxLength={1000}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        updateMaxLength('actionRemarks', isMaxLengthValid);
                                    }}
                                    onChange={(e) => {
                                        saveData('actionRemarks', e.target.value, index);
                                    }}
                                />
                            </Grid>
                            <Grid container className={classes.deviation}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>Deviation was caused by:</div>
                                    <div style={{ paddingLeft: 10 }}>
                                        <CustomSelect
                                            style={{ width: 200 }}
                                            disabled={!isPermission}
                                            fullWidth
                                            options={[
                                                { key: 0, label: 'Investigator error' },
                                                { key: 1, label: 'Subject error' },
                                                { key: 2, label: 'Others, please specify' },
                                            ]}
                                            value={
                                                item?.deviationCaused === 0 ||
                                                item?.deviationCaused === 1 ||
                                                item?.deviationCaused === 2
                                                    ? item?.deviationCaused
                                                    : null
                                            }
                                            setValue={(e) => {
                                                saveData('deviationCaused', e.target.value, index);
                                            }}
                                            validators={['isRequired']}
                                            label={'Deviation Caused'}
                                            name="deviationCaused"
                                            forceErrorDisplay={forceErrorDisplay}
                                        />
                                    </div>
                                </div>
                                <CustomTextField
                                    disabled={!isPermission || item?.deviationCaused !== 2}
                                    isTextArea
                                    name="deviationRemark"
                                    label="Deviation remark"
                                    value={item?.deviationRemark}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={item?.deviationCaused !== 2 ? [] : ['isRequired']}
                                    maxLength={1000}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        updateMaxLength('deviationRemark', isMaxLengthValid);
                                    }}
                                    style={{ paddingTop: 22 }}
                                    onChange={(e) => {
                                        saveData('deviationRemark', e.target.value, index);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default ProtocolDeviationDetails;
